export enum OrderPlatform {
  Instagram = 'instagram',
  TikTok = 'tiktok',
}

export enum OrderInteraction {
  Likes = 'likes',
  Followers = 'followers',
  Views = 'views',
}

export enum PaymentGateway {
  Stripe = 'STRIPE',
  Swish = 'SWISH',
  Trial = 'TRIAL',
  Shopify = 'SHOPIFY',
}

export enum PaymentStatus {
  Created = 'CREATED',
  Paid = 'PAID',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Cancelled = 'CANCELLED',
  Refunded = 'REFUNDED',
  Free = 'FREE',
}

export interface OrderPackage {
  platform: OrderPlatform;
  interaction: OrderInteraction;
  size: number;
  price: number;
  title: string;
  deliveryInMinutes: number;
  percentOff: number;
  rating: number;
  reviews: number;
  sku: string;
  image: string;
}

export interface PlatformReference {
  url: string;
  user: SocialMediaUser;
  post: SocialMediaPost | null;
}

export type SocialMediaUser = {
  id: string;
  url: string;
  username: string;
  name: string;
  avatar: string;
  followers: number;
};

export type SocialMediaPost = {
  id: string;
  url: string;
  description: string;
  thumbnail: string;
  comments: number;
  likes: number;
  views: number;
};

export type SocialMediaProfile = {
  user: SocialMediaUser;
  posts: SocialMediaPost[];
  next_page: string | null;
};

export interface Order {
  id: string;
  uuid: string;
  created_at: string;
  updated_at: string;
  platform: OrderPlatform;
  interaction: OrderInteraction;
  size: number;
  price: number;
  currency: string;
  price_in_sek: number;
  platform_reference: PlatformReference;
  email: string;
  paid_at: string | null;
  conversion_recorded_at: string | null;
  sent_at: string | null;
  delivered_at: string | null;
  smmflw_order_id: string | null;
  status: string;
}

export interface Payment {
  id: number;
  created_at: string;
  updated_at: string;
  order_id: number;
  gateway: PaymentGateway;
  gateway_id: string;
  gateway_reference: string | null;
  status: PaymentStatus;
}

export interface Tag {
  id: number;
  name: string;
}

export interface Post {
  id: number;
  published_at: string;
  slug: string;
  image_url: string;
  title: string;
  summary: string;
  reading_time: number;
  tags?: Tag[];
}

export interface Paginator<T> {
  current_page: number;
  data: T[];
  first_page_url: string;
  from: number;
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
}
